<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Delete clinic: {{ data && data.MSU_N ? data.MSU_N : '' }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="deleteData.MSU_N"
                        readonly
                        label="Clinic Name"
                        color="teal"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="teal darken-1 white--text"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        deleteData: {
            MSU_N: null,
            MSU_C: null
        }
    }),
    computed: {
        ...mapGetters(['deleteAccountClinicData']),
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        async deleteAccountClinicData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Clinic has been deleted'
                    this.notif.show = true
                    this.deleteData.MSU_N = null
                    this.showDialog = false
                    await this.viewAccountClinics({ ACCT_N: this.data.ACCT_N })
                    // this.$emit('refreshAcuList', this.data.ACCT_N)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        }
    },
    methods: {
        ...mapActions(['deleteAccountClinic', 'viewAccountClinics', 'acuActiveList']),
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.deleteAccountClinic({ ACCT_N: this.deleteData.ACCT_N, MSU_C: this.deleteData.MSU_C })
            }
        },
        initData() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.deleteData = structuredClone(this.data)
        }
    }
}
</script>
